import { axios } from "utils";

import { GLOBAL_TRACKING_URL as endpoint } from "consts";

export const sendUtmData = async (data) => axios.post(`${endpoint}/utm-data`, { data });

export const trackEmailLink = async (data) => axios.get(`${endpoint}/c/${data.token}`, { data });

export const trackPageView = async (data) => axios.post(`${endpoint}/v`, { data });

export const sendMixpanelTracking = async (data) => axios.post(`${endpoint}/m`, { data });
